export default function getResource(label) {
    const resources = {
        movedToSaveForLater: 'a été déplacé dans',
        saveForLater: 'Enregistrer pour plus tard',
        gotIt: 'Compris',
        undo: 'Annuler',
        viewSavedItems: 'Afficher les articles enregistrés',
        moveBackToBasket: 'Déplacer dans le panier',
        confirmationAriaLabel: 'enregistré pour une confirmation ultérieure'
    };

    return resources[label];
}
